import React, { Component } from "react";
import { connect } from "react-redux";

import { setCurrentChannel } from "../../store/channels";

import { Menu, Icon } from "semantic-ui-react";

class Starred extends Component {
    changeActiveChannel(starredChannel) {
        this.props.setCurrentChannel(starredChannel);

        this.props.setActiveChannel(starredChannel.id + "starred");
    }

    renderStarredChannel = starredChannel => (
        <Menu.Item
            key={starredChannel.id}
            name={starredChannel.channelName}
            className="starredChannel-item"
            active={this.props.activeChannel === starredChannel.id + "starred"}
            onClick={() => this.changeActiveChannel(starredChannel)}>
            # {starredChannel.channelName}
        </Menu.Item>
    );

    render() {
        const { starredChannels } = this.props.channels;

        return (
            <div className="starred">
                <Menu.Menu>
                    <Menu.Item>
                        <span>
                            <Icon name="star" /> STARRED
                        </span>
                        ({starredChannels.length})
                    </Menu.Item>

                    {starredChannels.map(this.renderStarredChannel)}
                </Menu.Menu>
            </div>
        );
    }
}

export default connect(null, { setCurrentChannel })(Starred);
